/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitUpdateEntityRelationQuotaRequest
 */
export interface MonitUpdateEntityRelationQuotaRequest {
    /**
     * 
     * @type {number}
     * @memberof MonitUpdateEntityRelationQuotaRequest
     */
    lite_quota?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitUpdateEntityRelationQuotaRequest
     */
    extended_quota?: number;
}

/**
 * Check if a given object implements the MonitUpdateEntityRelationQuotaRequest interface.
 */
export function instanceOfMonitUpdateEntityRelationQuotaRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitUpdateEntityRelationQuotaRequestFromJSON(json: any): MonitUpdateEntityRelationQuotaRequest {
    return MonitUpdateEntityRelationQuotaRequestFromJSONTyped(json, false);
}

export function MonitUpdateEntityRelationQuotaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitUpdateEntityRelationQuotaRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lite_quota': !exists(json, 'lite_quota') ? undefined : json['lite_quota'],
        'extended_quota': !exists(json, 'extended_quota') ? undefined : json['extended_quota'],
    };
}

export function MonitUpdateEntityRelationQuotaRequestToJSON(value?: MonitUpdateEntityRelationQuotaRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lite_quota': value.lite_quota,
        'extended_quota': value.extended_quota,
    };
}

